import { LD, useLDFlag } from '@dutchie-pos/utils';

import { useLocation } from 'src/queries/curbside/location-details';

/** Location feature 454. Separate from Register's 453 so either flow can be enabled alone. */
const CAMERA_ID_SCAN_MOBILE_CHECKOUT_FEATURE = 'CameraIdScanMobileCheckout';

/** Fails closed: both the global rollout and the location feature must be explicitly on. */
export const useCameraIdScanAccess = (): boolean => {
  const isRolloutEnabled = useLDFlag(LD.POS_CAMERA_ID_SCAN_ROLLOUT, false);
  const { data: location } = useLocation();

  return isRolloutEnabled && location?.Features?.[CAMERA_ID_SCAN_MOBILE_CHECKOUT_FEATURE] === true;
};
